export default __webpack_public_path__ + "static/media/rewards-card-img.afa0c0c2.png";